import { decode } from 'html-entities';

const stripTagsFallback = (value: string) => value.replace(/<[^>]*>/g, '');

export const decodeHtml = (input = '') => decode(input);
export const removeTags = (input = '') => {
  const decoded = decode(input);
  if (typeof DOMParser === 'undefined') {
    return stripTagsFallback(decoded);
  }

  const doc = new DOMParser().parseFromString(decoded, 'text/html');
  return doc.body?.textContent || '';
};
